module.exports = __webpack_public_path__ + "img/20231123_194643-2.bc25d18e.jpg";